// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2YXzI","title":"Images90_title__11wEn","images":"Images90_images__3YXNl"};